/** Обзвон — ровно то, что отдаёт `GET /api/deals/call-list`. */
import { apiFetch } from "@/lib/api";

export type CallType = { id: number; name: string };

export type UserRow = {
  /** 0 — «не назначен». */
  user_id: number;
  name: string;
  total: number;
  /** Тип обзвона → числа по группам попыток (`attempt_groups`). */
  cells: Record<string, number[]>;
};

export type DealRow = {
  id: number;
  type_id: number;
  stage_id: string;
  stage: string | null;
  location: string | null;
  /** Местное время салона в рабочих часах. */
  callable_now: boolean;
  local_time: string;
  wait_at: string | null;
  rent_start: string | null;
  rent_end: string | null;
  sum: number | null;
  paid: number | null;
  calls: number;
  attempt_group: number;
  last_call_at: string | null;
  last_success_at: string | null;
  user_id: number;
  user: string | null;
  created_at: string | null;
};

export type CallList = {
  now: string;
  work_hours: string;
  types: CallType[];
  attempt_groups: string[];
  totals: { deals: number; callable_now: number; assigned: number; unassigned: number; no_salon: number };
  users: UserRow[];
  deals: DealRow[];
};

export function loadCallList(): Promise<CallList> {
  return apiFetch<CallList>("/api/deals/call-list");
}
